<template>
  <div>
    <b-row>
      <b-col
        v-for="field in fields"
        :key="field.key"
        :sm="field.type === 'divider' ? 14 : field.cols ? field.cols : 6"
        :class="field.class"
      >
        <slot v-if="!field.skip" :name="field.key" :field="field">
          <div v-if="field.type === 'divider'" class="d-flex mt-2">
            <feather-icon v-if="field.icon" size="19" :icon="field.icon" />
            <h4 class="ml-50">
              {{ $t(field.label) }}
            </h4>
          </div>
          <b-form-group
            v-if="field.type !== 'divider'"
            :label-for="field.key"
            :description="getDesciption(field)"
            :class="field.class"
          >
            <validation-provider
              #default="{ errors }"
              :vid="field.key"
              :name="field.label"
              :rules="field.rules"
            >
              <label
                v-if="field.type !== 'checkbox' && !field.hideLabel"
                :class="
                  field.hiddenKey && data[field.hiddenKey] === field.hiddenValue
                    ? 'd-none'
                    : 'd-block'
                "
              >
                <!-- TODO: delete label -->
                <span>{{ $t(field.label) }}</span>
                <span v-if="isOptional(field.rules, field)" class="text-muted">
                  - {{ $t('field.optional') }}
                </span>
                <span v-if="field.labelSuffix"
                  >&nbsp; {{ $t(field.labelSuffix) }}</span
                >
                <span
                  v-if="!isOptionals(field.icon)"
                  :style="{ paddingLeft: '0.3rem' }"
                  class="text-muted"
                >
                  <span
                    v-b-tooltip.hover.righttop.v-secondary
                    :style="{}"
                    variant="outline-light"
                    class="button-tooltip"
                    :title="
                      field.tooltipContent
                        ? $t(field.tooltipContent)
                        : $t('field.nodeForService')
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-exclamation-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                      />
                    </svg>
                  </span>
                </span>
              </label>
              <!-- TODO: custom add logic hidden -->
              <b-form-input
                v-if="field.type === 'text'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :placeholder="
                  field.placeholder ? $t(field.placeholder) : $t(field.label)
                "
                :name="field.key"
                :disabled="field.disabled"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  field.hiddenKey && data[field.hiddenKey] === field.hiddenValue
                    ? 'd-none'
                    : ''
                ]"
                autocomplete="off"
                @input="onChange"
              />
              <b-form-textarea
                v-if="field.type === 'text-area'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :placeholder="
                  field.placeholder ? $t(field.placeholder) : $t(field.label)
                "
                :name="field.key"
                :disabled="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                autocomplete="off"
                @input="onChange"
              />
              <!-- TODO: custom add logic hidden -->
              <b-form-input
                v-if="field.type === 'number'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :type="field.type"
                :placeholder="
                  field.placeholder ? $t(field.placeholder) : $t(field.label)
                "
                :name="field.key"
                :disabled="field.disabled"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  field.hiddenKey && data[field.hiddenKey] === field.hiddenValue
                    ? 'd-none'
                    : ''
                ]"
                autocomplete="off"
                @input="onChange"
              />
              <b-form-datepicker
                v-if="field.type === 'date'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :locale="$i18n.locale"
                :name="field.key"
                :placeholder="$t(field.label)"
                :disabled="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                :date-format-options="{
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit'
                }"
                :reset-button="field.resetButton"
                v-bind="labels[$i18n.locale] || {}"
                :min="field.min"
                @input="onChange"
              />
              <b-form-timepicker
                v-if="field.type === 'time'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :locale="$i18n.locale"
                :name="field.key"
                :placeholder="$t(field.label)"
                :disabled="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                :hour12="field.hour12 || false"
                v-bind="labels[$i18n.locale] || {}"
                :min="field.min"
                @input="onChange"
              />
              <!-- TODO: custom add logic hidden -->
              <n-password-input
                v-if="field.type === 'password'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :placeholder="
                  field.placeholder ? $t(field.placeholder) : $t(field.label)
                "
                :errors="errors"
                :disabled="field.disabled"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  field.hiddenKey && data[field.hiddenKey] === field.hiddenValue
                    ? 'd-none'
                    : ''
                ]"
                @input="onChange"
              />
              <n-currency-input
                v-if="field.type === 'currency'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :placeholder="$t(field.label)"
                :errors="errors"
                :disabled="field.disabled"
                :prefix="field.prefix"
                :suffix="field.suffix"
                :translate-suffix="field.translateSuffix"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @input="onChange"
              />
              <n-color-picker
                v-if="field.type === 'color-picker'"
                :id="field.key"
                :pickerId="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :placeholder="$t(field.label)"
                :errors="errors"
                :showColorPlaceholder="field.showColorPlaceholder"
                :disabled="field.disabled"
                :prefix="field.prefix"
                :suffix="field.suffix"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @input="onChange"
              />
              <!-- TODO: custom add logic hidden -->
              <n-tel-input
                v-if="field.type === 'tel'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :placeholder="$t(field.label)"
                :errors="errors"
                :disabled="field.disabled"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  field.hiddenKey && data[field.hiddenKey] === field.hiddenValue
                    ? 'd-none'
                    : ''
                ]"
                @input="onChange"
              />
              <b-form-radio-group
                v-if="field.type === 'radio'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :disabled="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                buttons
                button-variant="outline-primary rounded-0"
                class="flex-wrap"
                @change="onChange"
              >
                <b-form-radio
                  v-for="option in field.options"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ $t(option.text) }}
                </b-form-radio>
              </b-form-radio-group>
              <b-form-checkbox
                v-if="field.type === 'checkbox'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :value="true"
                :unchecked-value="false"
                :disabled="field.disabled"
                :switch="field.switch"
                :class="errors.length > 0 ? 'is-invalid' : null"
                :button-variant="field.buttonVariant"
                :button="field.button"
                :size="field.size"
              >
                {{ $t(field.label) }}
              </b-form-checkbox>
              <n-single-image-uploader
                v-if="field.type === 'single-image'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :pw="field.pw"
                :ph="field.ph"
                :full-width="field.fullWidth"
                :image="data[field.initKey]"
                :readonly="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @change="onChange"
              />
              <n-multi-image-uploader
                v-if="field.type === 'multi-image'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :pw="field.pw"
                :ph="field.ph"
                :full-width="field.fullWidth"
                :image="data[field.initKey]"
                :readonly="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @change="onChange"
              />
              <n-async-single-image-uploader
                v-if="field.type === 'async-single-image'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :is-optional="isOptional(field.rules)"
                :is-optionals="isOptionals(field.icon)"
                :path="field.path"
                :pw="field.pw"
                :ph="field.ph"
                :full-width="field.fullWidth"
                :image="initValue[field.initKey]"
                :readonly="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @change="onChange"
              />
              <b-form-textarea
                v-if="field.type === 'textarea'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :placeholder="$t(field.label)"
                :rows="field.rows ? field.rows : 2"
                :max-rows="field.maxRows ? field.maxRows : 6"
                :readonly="field.disabled"
                :disabled="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @input="onChange"
              />
              <!-- TODO: custom add logic hidden -->
              <n-single-select
                v-if="field.type === 'single-selection'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :init-options="data[field.key]"
                :options="field.options"
                :selection-key="field.selectionKey"
                :selection-label="field.selectionLabel"
                :reduce="field.reduce ? true : false"
                :placeholder="field.placeholder ? field.placeholder : null"
                :readonly="field.disabled"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  field.hiddenKey && data[field.hiddenKey] === field.hiddenValue
                    ? 'd-none'
                    : ''
                ]"
                @input="onChange"
              />
              <n-multi-select
                v-if="field.type === 'multi-selection'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :init-options="data[field.key]"
                :options="field.options"
                :selection-key="field.selectionKey"
                :selection-label="field.selectionLabel"
                :readonly="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @input="onChange"
              />
              <n-async-multi-select
                v-if="field.type === 'async-multi-selection'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :init-options="data[field.key]"
                :repository="field.repository"
                :selection-key="field.selectionKey"
                :selection-label="field.selectionLabel"
                :readonly="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                :dependency-key="field.dependencyKey"
                :dependency-value="data[field.dependency]"
                @input="onChange"
              />
              <!-- TODO: custom add logic hidden -->
              <n-async-single-select
                v-if="field.type === 'async-single-selection'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :name="field.key"
                :init-options="data[field.key]"
                :repository="field.repository"
                :selection-key="field.selectionKey"
                :selection-label="field.selectionLabel"
                :isObject="field.isObject"
                :readonly="field.disabled"
                :clearable="field.clearable"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  field.hiddenKey && data[field.hiddenKey] === field.hiddenValue
                    ? 'd-none'
                    : ''
                ]"
                :showAddNew="field.showAddNew"
                @input="onChange"
                @add-new-hook="
                  field.handleAddNew ? field.handleAddNew() : () => {}
                "
              />
              <n-lat-lng-picker
                v-if="field.type === 'latlng-picker'"
                :id="field.key"
                :ref="field.key"
                v-model="data[field.key]"
                :latitude="Number(data[field.latitude])"
                :longitude="Number(data[field.longitude])"
                :name="field.key"
                :init-options="data[field.key]"
                :repository="field.repository"
                :selection-key="field.selectionKey"
                :selection-label="field.selectionLabel"
                :readonly="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @change="changeLatLng($event, field)"
              />
              <n-single-audio-uploader
                v-if="field.type === 'single-audio'"
                :ref="field.key"
                v-model="data[field.key]"
                :pw="field.pw"
                :ph="field.ph"
                :full-width="field.fullWidth"
                :audio="data[field.initKey]"
                :readonly="field.disabled"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @change="onChange"
              />
              <b-form-tags
                v-if="field.type === 'tags'"
                :id="field.key"
                v-model="data[field.key]"
                separator=",;"
                input-class="form-control form-tags"
                no-add-on-enter
                :placeholder="
                  field.placeholder ? $t(field.placeholder) : $t(field.label)
                "
                :remove-on-delete="true"
                :duplicate-tag-text="$t('error.duplicateTags')"
                :add-button-text="$t('button.add')"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </slot>
      </b-col>
    </b-row>
    <slot :model="data" :update="update"></slot>
  </div>
</template>

<script>
  import {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormRadioGroup,
    BFormRadio,
    BBadge,
    BRow,
    BCol,
    BFormTextarea,
    BFormCheckbox,
    BFormDatepicker,
    BButton,
    BIcon,
    BIconArrowUp,
    BAvatar,
    BFormTags,
    BFormTimepicker
  } from 'bootstrap-vue';
  import NPasswordInput from '@/components/NPasswordInput';
  import NAsyncMultiSelect from '@/components/NAsyncMultiSelect';
  import NMultiSelect from '@/components/NMultiSelect';
  import NAsyncSingleSelect from '@/components/NAsyncSingleSelect';
  import NSingleImageUploader from '@/components/NSingleImageUploader';
  import NMultiImageUploader from '@/components/NMultiImageUploader';
  import NSingleAudioUploader from '@/components/NSingleAudioUploader';
  import NCurrencyInput from '@/components/NCurrencyInput';
  import NTelInput from '@/components/NTelInput';
  import NSingleSelect from '@/components/NSingleSelect';
  import NAsyncSingleImageUploader from '@/components/NAsyncSingleImageUploader';
  import NLatLngPicker from '@/components/NLatLngPicker';
  import NColorPicker from '@/components/NColorPicker';
  import labels from '@/data/localeDatepicker';

  export default {
    components: {
      BFormGroup,
      BFormInput,
      BInputGroup,
      BInputGroupAppend,
      NPasswordInput,
      BFormRadioGroup,
      BFormRadio,
      NSingleImageUploader,
      NSingleAudioUploader,
      BBadge,
      BRow,
      BCol,
      BFormTextarea,
      NAsyncMultiSelect,
      NAsyncSingleSelect,
      BFormCheckbox,
      NCurrencyInput,
      NTelInput,
      NMultiSelect,
      NSingleSelect,
      BFormDatepicker,
      BFormTimepicker,
      NAsyncSingleImageUploader,
      NLatLngPicker,
      NColorPicker,
      BButton,
      BIcon,
      BIconArrowUp,
      BAvatar,
      BFormTags,
      NMultiImageUploader
    },
    props: {
      value: {},
      initValue: {
        type: Object,
        default() {
          return {};
        }
      },
      fields: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        data: {},
        labels
      };
    },
    computed: {},
    watch: {
      data(newValue, oldValue) {
        this.$emit('input', newValue);
      },
      initValue(newValue, oldValue) {
        this.data = {
          ...this.data,
          ...newValue
        };
      }
    },
    mounted() {
      this.data = {
        ...this.value
      };
    },
    methods: {
      setValue(value) {
        this.data = {
          ...value
        };
      },
      getDesciption(field) {
        const image = ['single-image', 'async-single-image', 'multi-image'];
        if (image.includes(field.type)) {
          return this.$t('general.recommendDimension', {
            ph: field.ph,
            pw: field.pw
          });
        }
        if (field.hint) {
          return this.$t(field.hint);
        }
        return '';
      },
      isOptional(rules, field) {
        if (field.fakeRequired) {
          return false;
        }

        if (!rules) {
          return true;
        }

        return !rules.includes('required');
      },
      isOptionals(icon) {
        if (!icon) {
          return true;
        }

        return !icon.includes('icon');
      },
      onChange() {
        this.$emit('input', this.data);
      },
      update(newValue, keys) {
        for (const key of keys) {
          this.data[key] = newValue[key];
        }
      },
      changeLatLng(position, field) {
        this.data[field.latitude] = position.lat;
        this.data[field.longitude] = position.lng;
      }
    }
  };
</script>

<style>
  .form-tags.form-control {
    height: calc(2.714rem - 0.44rem * 2);
  }
  .form-tags.form-control:focus {
    box-shadow: none !important;
  }
</style>
